import React from "react";
import CustomModal from "../../common/CustomModal";

interface AddRoleModalProps {
  show: boolean;
  onHide: () => void;
  roleName: string;
  description: string;
  onRoleNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onSubmit: () => void;
}

export const AddRoleModal: React.FC<AddRoleModalProps> = ({
  show,
  onHide,
  roleName,
  description,
  onRoleNameChange,
  onDescriptionChange,
  onSubmit,
}) => {
  return (
    <CustomModal show={show} onHide={onHide} title="Role" width="w-[500px]">
      <div className="w-full">
        <div className="space-y-4">
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Role Name</label>
            <input
              type="text"
              value={roleName}
              onChange={(e) => onRoleNameChange(e.target.value)}
              placeholder="Enter role name"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
          <div className="space-y-2">
            <label className="block text-sm font-medium text-gray-700">Description</label>
            <input
              type="text"
              value={description}
              onChange={(e) => onDescriptionChange(e.target.value)}
              placeholder="Enter role description"
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none"
            />
          </div>
        </div>
        <div className="flex justify-between gap-4 mt-8">
          <button
            onClick={onHide}
            className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            className="px-4 py-2 text-sm font-medium text-white bg-brand rounded-md hover:bg-brand/80 focus:outline-none"
          >
            Add Role
          </button>
        </div>
      </div>
    </CustomModal>
  );
};
